module.exports = __webpack_public_path__ + "img/dashboard_as_icon.79d420e9.svg";